import React, { useEffect, useState } from "react";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import BaseTextareaAutosize from '@mui/material/TextareaAutosize';

import { styled, width } from '@mui/system';
import dayjs, { Dayjs } from 'dayjs';
import { useDispatch, useSelector } from "react-redux";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';

import PermitListItem from './PermitListItem';

import { setFullLoad, setSnackMsg } from "../../redux/actions/common";
import { baseUrl, headers, mandatoryFields } from "../../constants";
import { getDropDown } from "../../redux/selector";
import { findMissingFields } from "../../utils";
import {
  getDDFacilityCall, getDDEquCall, getDDSubEquipTagCall,
  getDDDeviceTagCall, getDDJobProCall, getDDJobNatureCall,
  getDDWorkCall, getDDEmployeeCall, getDDJobStatusCall,
  getDDTagCall, getDDWorkCenterCall, getDDTaskCall,
  getDDDeptCall, getDDequipTypeCall, getDDEquipmentCapacityCall,
  getDDEquipmentTagCall
} from "../../redux/actions/dropDown";
import { dropDownNode } from "../../utils";
import RichTextEditor from "../RichTextEditor";
import DropdownMenu from "../DropdownMenu";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import OutlinedInput from '@mui/material/OutlinedInput';
import { useTheme } from '@mui/material/styles';
import ListItemText from '@mui/material/ListItemText';


function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}
export default function Forms({ handleClose, formDataObj = {}, fetchTableData, userDetails, WOType }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const dropDownState = useSelector(getDropDown);
  const isDailyLog = WOType === "daily";

  const [dropDownVal, setDropDownVal] = useState(dropDownState || {});
  const [age, setAge] = React.useState('');
  const [addSimilar, setAddSimilar] = useState(false);
  const isEdit = formDataObj?.formType === 'edit';
  const isView = formDataObj?.formType === 'view' && !addSimilar;
  const viewStyle = { pointerEvents: isView ? "none" : false };

 const [personName, setPersonName] = React.useState([]);
   const handleChange = (event) => {
    setAge(event.target.value);
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  // const [formData, setFormData] = useState(formDataObj);
  const [formData, setFormData] = useState({
    // order_date: dayjs(new Date()).format('DD-MM-YYYY'),
    ...formDataObj,
    detailedJobDescription: '',
  });
  const [tempData, setTempData] = useState({
    startDate: null, endDate: null,
    breakStartDate: null, breakEndDate: null
  });
  
  const handleTree = (name, value) => {
    let planFacility = formData.planFacility;
    let equipment = formData.equipment;
    let equipmentType = formData.equipmentType;
    let equipmentCapacity = formData.equipmentCapacity;
    let equipmentTag = formData.equipmentTag;
    let subEquipmentTag = formData.subEquipmentTag;
    let deviceTag = formData.deviceTag;
    if(name === 'area') {
      planFacility = ''; equipment = ''; equipmentType = ''; 
      equipmentCapacity = ''; equipmentTag = '';
      dispatch(getDDFacilityCall({area_id: value}));
    }
    else if(name === 'planFacility') {
      equipment = ''; equipmentType = ''; equipmentCapacity = ''; equipmentTag = '';
      dispatch(getDDEquCall({facility_id: value}));
    }
    else if(name === 'equipment') {
      equipmentType = ''; equipmentCapacity = ''; equipmentTag = '';
      dispatch(getDDequipTypeCall({equipment_id: value}));
    }
    else if(name === 'equipmentType') {
      equipmentCapacity = ''; equipmentTag = '';
      dispatch(getDDEquipmentCapacityCall({equipment_type_id: value}));
    }
    else if(name === 'subEquipment') {
      equipmentType = ''; equipmentCapacity = ''; equipmentTag = ''; subEquipmentTag = '';
      dispatch(getDDSubEquipTagCall({sub_equipment_id: value}));
    }
    else if(name === 'deviceInstrument') {
      equipmentType = ''; equipmentCapacity = ''; equipmentTag = ''; deviceTag = '';
      dispatch(getDDDeviceTagCall({device_id: value}));
    }
    else if(name === 'equipmentCapacity') {
      equipmentTag = '';
      dispatch(getDDEquipmentTagCall({equipment_capacity_id: value}));
    }
    // return {
    //   planFacility, equipment, equipmentTag,
    //   equipmentType, equipmentCapacity
    // };
  };

  const handleInputChange = (e, type) => {
    const { name, value } = e.target;
    // Support both event and direct object (for jobPermit from PermitListItem)
    if (name === 'jobPermit') {
      // Called from PermitListItem, e.g. { [id]: value }
      const id = Object.keys(value)[0];
      const permitValue = value[id];
      setFormData((prev) => {
        let jobPermitArr = Array.isArray(prev.jobPermit) ? [...prev.jobPermit] : [];
        // Remove if value is empty, else add/update
        if (permitValue === "") {
          jobPermitArr = jobPermitArr.filter((item) => item.id !== id);
        } else {
          // If already exists, update value; else add new
          const idx = jobPermitArr.findIndex((item) => item.id === id);
          if (idx > -1) {
            jobPermitArr[idx] = { id, permitValue };
          } else {
            jobPermitArr.push({ id, permitValue });
          }
        }
        return { ...prev, jobPermit: jobPermitArr };
      });
      return;
    }
    // ...existing code...
    handleTree(name, value);
    if( type === 'temp' ){
      setTempData((prev) => ({ ...prev, [name]: value }));
    }
    else{
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  useEffect(() => {
    let TotalDuration = 0;
    let BreakDownDuration = 0;
    const oneDay = 24 * 60 * 60 * 1000; 
    if( tempData.startDate && tempData.endDate ) {
      TotalDuration = (new Date(tempData.endDate) - new Date(tempData.startDate))/oneDay;
    }
    if( tempData.breakStartDate && tempData.breakEndDate ) {
      BreakDownDuration = (new Date(tempData.breakEndDate) - new Date(tempData.breakStartDate))/oneDay;
    }
    setFormData((prev) => ({ ...prev, 
      BreakDownDuration, TotalDuration
     }));
  }, [
    tempData.startDate, tempData.endDate,
    tempData.breakStartDate, tempData.breakEndDate
  ]);

  const handleDateChange = (date, field) => {
    setFormData({
      ...formData,
      [field]: date
    });
  };
  const handleSubmitForm = () => {
    dispatch(setFullLoad(true));
    const missingFields = findMissingFields(formData, mandatoryFields);
    console.log("add- work-order --", formData, missingFields);
    if( missingFields.length > 0 ) {
      dispatch(setSnackMsg({
        open: true,
        error: true,
        msg: `Missing Fields - ${missingFields.join(', ')}` 
      }));
      dispatch(setFullLoad(false));
      return false;
    }
    const formDataVal = {
      ...formData,
      jobPermit: formData.jobPermit?.length ? JSON.stringify(formData.jobPermit || []) : '',
      add_by: 1
    };
    if (isDailyLog) { formDataVal.w_type = 2; }
    delete formDataVal.order_date;
    delete formDataVal.formType;
    const api_type = isDailyLog ? 'daily_log' : 'work_order';
    
    console.log("final value --", formDataVal);
    // return ;

    fetch(`${baseUrl}/api/work/${api_type}${isEdit ? '/edit' : ''}`, {
      method: "POST",
      body: JSON.stringify(formDataVal),
      headers
    })
      .then((response) => {
        return response.json();
      })
      .then(data => {
        console.log("add- work-order --", data.message);
        const isError = data?.statusCode !== 200;
        dispatch(setFullLoad(false));
        dispatch(setSnackMsg({
          open: true,
          error: isError,
          msg: data.message
        }));
        if (!isError) {
          if (isDailyLog) {
            handleClearForm();
            window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth' // Optional: 'auto' for instant scrolling
            });
          }
          handleClose();
          fetchTableData();
        }
      });
  }
  const handleClearForm = () => {
    setFormData({
      formType: formDataObj.formType,
      orderNumber: '',
      orderType: '',
      shortJobDescription: '',
      detailedJobDescription: '',
      area: '',
      planFacility: '',
      equipment: '',
      subEquipment: '',
      deviceInstrument: '',
      tag: '',
      jobPriority: '',
      createdBy: '',
      reportedBy: '',
      assignedTo: '',
      orderFrom: null,
      orderTo: null,
      // order_date: dayjs(new Date()).format('DD-MM-YYYY')
    });
  };
  const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
  };
  const Textarea = styled(BaseTextareaAutosize)(
    ({ theme }) => `
    box-sizing: border-box;
   
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};   
  `,
  );

  const [fields, setFields] = useState([{ value: '' }]);

  // useEffect(() => {
  //   fetchDropDown(dispatch, [
  //     getDDFacilityCall, getDDEquCall, getDDSubEquCall,
  //     getDDDeviceCall, getDDJobProCall, getDDJobNatureCall,
  //     getDDWorkCall, getDDEmployeeCall, getDDJobStatusCall,
  //     getDDTagCall, getDDWorkCenterCall, getDDTaskCall,
  //     getDDDeptCall
  //   ]);
  // }, [])

  useEffect(() => {
    setDropDownVal(dropDownState || {});
  }, [dropDownState]);

  const [alignment, setAlignment] = React.useState('repeat');

  const [dwmyalignment, setDwmyAlignment] = React.useState('day');


  const handletoggleChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };


  const handledwmyChange = (event, newAlignment) => {
    if (newAlignment !== null) {
      setDwmyAlignment(newAlignment);
    }
  };
  const [dwmalignment, dwmsetAlignment] = React.useState('day');



  const handledwmChange = (event, newAlignment) => {
    dwmsetAlignment(newAlignment);
  };
  const maxLength = 225;
  const currentLength = formData.detailedJobDescription.length;

  return (
    <Box className="w-full">
      <Grid className='bg-slate-100 '>
        <form>
         
          <div className='text-left bg-white  m-2 border-solid border rounded' style={viewStyle}>
            <div className='border-slate-300 rounded-md  '>
              <h3 className='border-b-2  p-2 bg-gray-200'>Assets</h3>
            </div>
            <div className='grid grid-cols-1 gap-4 md:grid-cols-3  p-3 mms-selectfield'>
              <FormControl sx={{ minWidth: 207 }}>
                <InputLabel id="area">Area</InputLabel>
                <Select className='mms-select'
                  name="area"
                  value={formData.area}
                  label="area"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.area_id || [])}
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 207 }}>
                <InputLabel id="plantFacility">Plan / Facility</InputLabel>
                <Select className='mms-select'
                  name="planFacility"
                  value={formData.planFacility}
                  label="Plant / Facility"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.facility_id || [])}
                </Select>
              </FormControl>

              <FormControl sx={{ minWidth: 207 }}>
                <InputLabel id="equipment">Equipment</InputLabel>
                <Select className='mms-select'
                  name="equipment"
                  value={formData.equipment}
                  label="Equipment"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.equipment_id || [])}
                </Select>
              </FormControl>
<FormControl sx={{ minWidth: 207 }}>
                <InputLabel id="equipmenttype">Equipment Type</InputLabel>
                <Select className='mms-select'
                  name="equipmentType"
                  value={formData.equipmentType}
                  label="equipmenttype"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.equipmentType || [])}
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 207 }}>
                <InputLabel id="equipmentcapacity">Equipment Capacity</InputLabel>
                <Select className='mms-select'
                  name="equipmentCapacity"
                  value={formData.equipmentCapacity}
                  label="equipmentcapacity"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.equipmentCapacity || [])}
                </Select>
              </FormControl>
               <FormControl sx={{ minWidth: 207 }}>
                <InputLabel id="equipmenttag">Equipment Tag</InputLabel>
                <Select className='mms-select'
                  name="equipmentTag"
                  value={formData.equipmentTag}
                  label="equipmenttag"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.equipmentTag || [])}
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 207 }}>
                <InputLabel id="subEquipment">Sub -Equipment</InputLabel>
                <Select className='mms-select'
                  name="subEquipment"
                  value={formData.subEquipment}
                  label="Sub -Equipment"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.sub_equipment_id || [])}
                </Select>
              </FormControl>
              <FormControl sx={{ minWidth: 207 }}>
                <InputLabel id="subEquipmenttag">Sub -Equipment Tag</InputLabel>
                <Select className='mms-select'
                  name="subEquipmentTag"
                  value={formData.subEquipmentTag}
                  label="Sub -Equipmenttag"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.subEquipmentTag || [])}
                </Select>
              </FormControl>

              <FormControl sx={{ minWidth: 207 }}>
                <InputLabel id="deviceInstrument">Device / Instrument</InputLabel>
                <Select className='mms-select'
                  name="deviceInstrument"
                  value={formData.deviceInstrument}
                  label="Device / Instrument"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.device_id || [])}
                </Select>
              </FormControl>

              <FormControl sx={{ minWidth: 207 }}>
                <InputLabel id="DeviceTag">Device / Instrument Tag</InputLabel>
                <Select className='mms-select'
                  name="deviceTag"
                  value={formData.deviceTag}
                  label="DeviceTag"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.deviceTag || [])}
                </Select>
              </FormControl>



             

            </div>
          </div>
           <div className='text-left bg-white  m-2 border-solid border rounded' style={viewStyle}>
            <div className='border-slate-300 flex  bg-gray-200 items-center'>
              <h3 className='border-b-2  p-2'>Order Details</h3>
              {/* <div className="ml-auto">
                <Button className="dig_btn">Fault List</Button>
                <Button className="dig_btn">Add</Button>
              </div> */}
            </div>
            <div className=' p-3 mms-date-field'>
              <Grid xs={12} md={12} container rowSpacing={3} columnSpacing={2}>
                <Grid item xs={12} md={12} container rowSpacing={3} columnSpacing={2}>
                  {/* <Grid item xs={12} md={3} >
                    <TextField size='small' label="Order Number" variant="outlined"
                      name="orderNumber"
                      value={formData.orderNumber}
                      sx={{ width: '100%' }}
                      onChange={handleInputChange} />
                  </Grid> */}
                  {isDailyLog ? '' : <>
                    <Grid item xs={12} md={4} className="mms-selectfield">
                      <FormControl sx={{ width: '100%' }}>
                        <InputLabel id="planFacility">Order Type</InputLabel>
                        <Select className='mms-select'
                          name="orderType"
                          value={formData.orderType}
                          label="orderType"
                          onChange={handleInputChange}

                        >
                          {dropDownNode(dropDownVal.orderType || [])}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4} className="mms-selectfield">
                      <FormControl sx={{ width: '100%' }}>
                        <InputLabel id="planFacility">Order From</InputLabel>
                        <Select className='mms-select'
                          name="orderFrom"
                          value={formData.orderFrom ||
                            userDetails?.department_id}
                          label="orderFrom"
                          onChange={handleInputChange}

                        >
                          {dropDownNode(dropDownVal.department_id || [])}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4} className="mms-selectfield">
                      <FormControl sx={{ width: '100%' }}>
                        <InputLabel id="planFacility">Order To</InputLabel>
                        <Select className='mms-select'
                          name="orderTo"
                          value={formData.orderTo || (
                            (formData.orderType === 1 || formData.orderType?.id === 1) ? userDetails?.department_id : '')}
                          label="orderTo"
                          onChange={handleInputChange}

                        >
                          {dropDownNode(dropDownVal.department_id || [])}
                        </Select>
                      </FormControl>
                    </Grid></>}

                  <Grid item xs={12} md={12} container>
                    <Grid item xs={12} md={11} container>
                      <TextField size='small' label="Short Job Description" variant="outlined"
                        name="shortJobDescription"
                        value={formData.shortJobDescription}
                        inputProps={{ maxLength: 100 }}
                        onChange={handleInputChange} sx={{ width: '100%' }} />
                    </Grid>
                    <Grid item xs={12} md={1} container>
                      <DropdownMenu />
                    </Grid>
                  </Grid>
<Grid item xs={12} md={12} container className="mms-selectfield" rowSpacing={3} columnSpacing={2}>
 <Grid item xs={12} md={3} >


<FormControl sx={{ width: '100%' }}>
                <InputLabel id="area">Job Nature</InputLabel>
                <Select className='mms-select'
                  name="area"
                  value={formData.area}
                  label="Job Nature"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.job_nature_id || [])}
                </Select>
              </FormControl>
 </Grid>
  <Grid item xs={12} md={3} >
 <FormControl sx={{ width: '100%' }}>
                <InputLabel id="jobPriority">Job Priority</InputLabel>
                <Select className='mms-select'
                  name="jobPriority"
                  value={formData.jobPriority}
                  label="Job Priority"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.job_priority_id || [])}
                </Select>
              </FormControl>
 </Grid>
  <Grid item xs={12} md={3} >
  <FormControl sx={{ width: '100%' }}>
                <InputLabel id="createdBy">Created By</InputLabel>
                <Select className='mms-select'
                  name="createdBy"
                  value={formData.createdBy}
                  label="Created By"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.employee_id || [])}
                </Select>
              </FormControl>
 </Grid>
  <Grid item xs={12} md={3} >
 <FormControl sx={{ width: '100%' }}>
                <InputLabel id="reportedBy">Reported By</InputLabel>
                <Select className='mms-select'
                  name="reportedBy"
                  value={formData.reportedBy}
                  label="Reported By"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.employee_id || [])}
                </Select>
              </FormControl>
 </Grid>

</Grid>
                 
                </Grid>
              </Grid>
            </div>
          </div>
         
          {(WOType === 'scheduled') ? <div className='text-left bg-white  m-2 border-solid border rounded' style={viewStyle}>
            <div className='border-slate-300 rounded-md  '>
              <h3 className='border-b-2  p-2 bg-gray-200'>Scheduled work order</h3>
            </div>
            <div className='p-3'>
              <Grid xs={12} md={12} container rowSpacing={3} columnSpacing={2}>
                <Grid item xs={12} md={12} container rowSpacing={3} columnSpacing={2} className="items-baseline">
                  <Grid item xs={12} md={6} container rowSpacing={3} columnSpacing={2}>
                    <Grid item xs={12} md={4}>
                      <h4 className="text-right">Repeat Type</h4>
                    </Grid>
                    <Grid item xs={12} md={8} >

                      <ToggleButtonGroup
                        color="primary"
                        value={alignment}
                        exclusive
                        onChange={handletoggleChange}
                        aria-label="Platform"
                        className="mms-select-one-btn"
                      >
                        <ToggleButton value="repeat">Repeat</ToggleButton>
                        <ToggleButton value="Onetime">One Time</ToggleButton>
                      </ToggleButtonGroup>
                    </Grid>
                    <Grid item xs={12} md={4} >
                      <h4 className="text-right">Intervals<br /> (Whichever come first) :</h4>
                    </Grid>
                    {alignment === 'repeat' && (
                      <>
                        <Grid item xs={12} md={8} >
                          <FormControlLabel control={<Checkbox defaultChecked />} label="Every" />
                          <TextField size='small' label="Hours" variant="outlined"
                            name="hours"
                            value={formData.hours}
                            sx={{ width: '110px' }}
                            onChange={handleInputChange} />
                        </Grid>
                        <Grid item xs={12} md={4} />
                        <Grid item xs={12} md={8} className="lg:flex">
                          <FormControlLabel control={<Checkbox defaultChecked />} label="Every" />
                          <TextField size='small' label="" variant="outlined"
                            name="hours"
                            value={formData.hours}
                            sx={{ width: '100px', marginRight: '5px' }}
                            onChange={handleInputChange} />
                          <ToggleButtonGroup
                            color="primary"
                            value={dwmyalignment}
                            exclusive
                            onChange={handledwmyChange}
                            aria-label="Platform"
                            className="mms-select-one-btn"
                          >
                            <ToggleButton value="day">Day</ToggleButton>
                            <ToggleButton value="Week">Week</ToggleButton>
                            <ToggleButton value="Month">Month</ToggleButton>
                            <ToggleButton value="Year">Year</ToggleButton>
                          </ToggleButtonGroup>
                        </Grid>
                      </>
                    )}
                    {alignment === 'Onetime' && (
                      <>
                        <Grid item xs={12} md={8} >
                          <FormControlLabel control={<Checkbox defaultChecked />} label="At" />
                          <TextField size='small' label="Hours" variant="outlined"
                            name="hours"
                            value={formData.hours}
                            sx={{ width: '110px' }}
                            onChange={handleInputChange} />
                        </Grid>
                        <Grid item xs={12} md={4} />
                        <Grid item xs={12} md={8} className="lg:flex">
                          <FormControlLabel control={<Checkbox defaultChecked />} label="On" />
                          <FormControl sx={{ width: '100%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={['DatePicker']}>
                                <DatePicker
                                  sx={{ width: '100%' }}
                                  name="orderFrom"
                                  value={dayjs(formData.orderFrom || null)}
                                  label="OrderFrom"
                                  onChange={(newValue) => {
                                    const dateFormatedVal = dayjs(newValue).format('YYYY-MM-DD');
                                    handleInputChange({
                                      target: {
                                        value: dateFormatedVal,
                                        name: "orderFrom"
                                      }
                                    })
                                  }}
                                  format='DD-MM-YYYY'
                                  slotProps={{
                                    textField: {
                                      error: false,
                                    },
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </FormControl>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} md={4}>
                      <h4 className="text-right">Assign to: </h4>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <TextField size='small' label="" variant="outlined"
                        name="hours"
                        value={formData.hours}
                        sx={{ width: '100%' }}
                        onChange={handleInputChange} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <h4 className="text-right">Automatically Generate Wo: </h4>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <FormControlLabel control={<Checkbox defaultChecked />} label="Yes" />

                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} container rowSpacing={3} columnSpacing={2}>
                    <Grid item xs={12} md={4}>
                      <h4 className="text-right">Notify before :</h4>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <FormControlLabel control={<Checkbox defaultChecked />} label="Every" />
                      <TextField size='small' label="Hours" variant="outlined"
                        name="hours"
                        value={formData.hours}
                        onChange={handleInputChange} sx={{ width: '100px', marginRight: '5px' }} />
                    </Grid>
                    <Grid item xs={12} md={4}></Grid>
                    <Grid item xs={12} md={8} className="lg:flex">
                      <TextField size='small' label="" variant="outlined"
                        name="hours"
                        value={formData.hours}
                        onChange={handleInputChange} sx={{ width: '100px' }} />
                      <ToggleButtonGroup
                        color="primary"
                        value={dwmalignment}
                        exclusive
                        onChange={handledwmChange}
                        aria-label="Platform"
                        className="mms-select-one-btn"
                      >
                        <ToggleButton value="day">Day</ToggleButton>
                        <ToggleButton value="Week">Week</ToggleButton>
                        <ToggleButton value="Month">Month</ToggleButton>
                      </ToggleButtonGroup>
                    </Grid>
                  </Grid>


                </Grid>


              </Grid>
            </div>
          </div> : ''}
          {(isEdit || isView || isDailyLog) ? <div className='text-left bg-white  m-2 border-solid border rounded' style={viewStyle}>
            <div className='border-slate-300 rounded-md  '>
              <h3 className='border-b-2  p-2 bg-gray-200'>Activity Details</h3>
            </div>
            <div className='p-3'>
              <Grid xs={12} md={12} container rowSpacing={3} columnSpacing={2}>
                <Grid item xs={12} md={12} container rowSpacing={1} columnSpacing={2}>

                  <Grid item xs={12} md={4} className="mms-selectfield">
                    <fieldset style={{border:'1px solid #c4c4c4',borderRadius:'4px',padding:'0 5px 0 15px'}}>
                      <legend color="#767373">Job Permit</legend>
                       <div style={{minHeight:'200px',maxHeight:'200px',overflowY:'auto',paddingRight:'5px'}}>
                      <ul>
                        {dropDownVal?.work_permit_id?.map?.((permit) => (
                          <PermitListItem key={`${permit.id}_${permit.name}`} permit={permit} handleInputChange={handleInputChange} />
                        ))}
                      </ul>
                    </div>
                    </fieldset>
                   
                   
  

                    {/* <FormControl sx={{ width: '100%' }}>
                      <InputLabel id="jobPermit">Job Permit</InputLabel>
                      <Select className='mms-select'
                        name="jobPermit"
                        value={formData.jobPermit}
                        label="jobPermit"
                        onChange={handleInputChange}

                      >
                        {dropDownNode(dropDownVal.work_permit_id || [])}
                      </Select>
                    </FormControl> */}
                  </Grid>
                  {/* <Grid item xs={12} md={4}>
                    <TextField size='small' label="Job Permit No" variant="outlined" sx={{ width: '100%' }}
                      name="jobpermitno"
                      value={formData.jobpermitno}
                      onChange={handleInputChange} />
                  </Grid> */}
                  <Grid item xs={12} md={8} container rowSpacing={1} columnSpacing={2}>
                   <Grid item xs={12} md={4} className="mms-selectfield">
                    <FormControl sx={{ width: '100%' }}>
                      <InputLabel id="VendorContractor">Vendor / Contractor</InputLabel>
                      <Select className='mms-select'
                        name="VendorContractor"
                        value={formData.VendorContractor}
                        label="vendor"
                        onChange={handleInputChange}

                      >
                        {dropDownNode(dropDownVal.vendor_id || [])}
                      </Select>
                    </FormControl>

                  </Grid>

                  <Grid item xs={12} md={4} className="mms-datepicker">
                    <LocalizationProvider label="Start Date" dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DateTimePicker']}>
                        <DateTimePicker 
                        label="Start Date" 
                        format="DD/MM/YYYY HH:mm" 
                        onChange={(newValue) => {
                          const dateFormatedVal = dayjs(newValue).format('YYYY-MM-DD');
                          handleInputChange({
                            target: {
                              value: dateFormatedVal,
                              name: "startDate"
                            }
                          }, 'temp')
                        }}
                        ampm={false} />
                      </DemoContainer>
                    </LocalizationProvider>

                  </Grid>
                  <Grid item xs={12} md={4} className="mms-datepicker">
                    <LocalizationProvider label="End Date" dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DateTimePicker']}>
                        <DateTimePicker 
                        label="End Date" 
                        format="DD/MM/YYYY HH:mm" 
                        onChange={(newValue) => {
                          const dateFormatedVal = dayjs(newValue).format('YYYY-MM-DD');
                          handleInputChange({
                            target: {
                              value: dateFormatedVal,
                              name: "endDate"
                            }
                          }, 'temp')
                        }}
                        ampm={false} />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField size='small' label="Total Duration" variant="outlined"
                      name="TotalDuration" sx={{ width: '100%' }}
                      value={formData.TotalDuration}
                      onChange={handleInputChange} />
                  </Grid>
                  <Grid item xs={12} md={4} className="mms-datepicker">
                    <LocalizationProvider label="End Date" dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DateTimePicker']}>
                        <DateTimePicker label="Break Down Start"
                        onChange={(newValue) => {
                          const dateFormatedVal = dayjs(newValue).format('YYYY-MM-DD');
                          handleInputChange({
                            target: {
                              value: dateFormatedVal,
                              name: "breakStartDate"
                            }
                          }, 'temp')
                        }} 
                        format="DD/MM/YYYY HH:mm" ampm={false} />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={4} className="mms-datepicker">
                    <LocalizationProvider label="End Date" dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DateTimePicker']}>
                        <DateTimePicker label="Break Down End" 
                        onChange={(newValue) => {
                          const dateFormatedVal = dayjs(newValue).format('YYYY-MM-DD');
                          handleInputChange({
                            target: {
                              value: dateFormatedVal,
                              name: "breakEndDate"
                            }
                          }, 'temp')
                        }} 
                        format="DD/MM/YYYY HH:mm" ampm={false} />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField size='small' label="Total Break Down Duration" variant="outlined"
                      name="BreakDownDuration" sx={{ width: '100%' }}
                      value={formData.BreakDownDuration}
                      onChange={handleInputChange} />
                  </Grid>
                 </Grid>
                </Grid>
                 <Grid item xs={12} md={12} >
                    <div>

                      <Typography>Detailed Job Description</Typography>
                      <RichTextEditor />
                      {/* <Typography
                        variant="body2"
                        sx={{
                          textAlign: 'right',
                          color: currentLength >= maxLength * 0.8 ? 'red' : 'gray', 
                          mt: 1,
                        }}
                      >
                        {`${currentLength}/${maxLength}`}
                        Characters
                      </Typography> */}
                    </div>
                  </Grid>
                <Grid item xs={12} md={12} >
                  <Typography>Root Cause / Analysis</Typography>
                  <RichTextEditor />

                </Grid>
                <Grid item xs={12} md={12} >
                  <Typography>Action Taken</Typography>
                  <RichTextEditor />

                </Grid>
                <Grid item xs={12} md={12}>
                  <Typography>Material Consumed</Typography>
                  <RichTextEditor />

                </Grid>
                <Grid item xs={12} md={12} >
                  <Typography>Special Tools Used</Typography>
                  <RichTextEditor />

                </Grid>
                <Grid item xs={12} md={12} >
                  <Typography>Safety Precaution Taken</Typography>
                  <RichTextEditor />

                </Grid>
                <Grid item xs={12} md={12} >
                  <Typography>Special Notes</Typography>
                  <RichTextEditor />
                </Grid>
                <Grid item xs={12} md={12} >
                  <Typography>Remarks</Typography>
                  <RichTextEditor />
                </Grid>
                 <Grid item xs={12} md={4} className="mms-selectfield">
                 <FormControl sx={{ width: '100%' }}>
                <InputLabel id="work_center">Work Center</InputLabel>
                <Select className='mms-select'
                  name="work_center"
                  value={formData.work_center}
                  label="Work Center"
                  onChange={handleInputChange}
                >
                  {dropDownNode(dropDownVal.work_center || [])}
                </Select>
              </FormControl>
              </Grid>
                <Grid item xs={12} md={4} className="mms-selectfield">
                  <FormControl sx={{ width: '100%', }}>
                    <InputLabel id="AttendedBys">Attended By</InputLabel>
                    <Select className='mms-select'
                      name="AttendedBys"
                      value={formData.AttendedBys}
                      label="Job Status"
                      onChange={handleInputChange}
                    >
                      {dropDownNode(dropDownVal.AttendedBys || [])}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4} className="mms-selectfield">
                  <FormControl sx={{ width: '100%', }}>
                    <InputLabel id="job_status">Job Status</InputLabel>
                    <Select className='mms-select'
                      name="job_status"
                      value={formData.job_status}
                      label="Job Status"
                      onChange={handleInputChange}
                    >
                      {dropDownNode(dropDownVal.job_status || [])}
                    </Select>
                  </FormControl>
                </Grid>

              </Grid>
            </div>
          </div> : ''}



          <div className='mt-5 flex justify-center'>
            {(!isView || addSimilar) ? <div className=''>
              <Button variant="contained" color="success" onClick={handleSubmitForm}>Submit</Button>
            </div> : ''}
            {!addSimilar && <div className='mx-1'>
              <Button variant="contained" className='mx-1.5' onClick={() => {
                setAddSimilar(true);
              }}>
                Add Similar
              </Button>
            </div>}
            {(!isView || addSimilar) ? <div>
              <Button variant="contained" className='bg-amber-500' onClick={handleClearForm}>
                Clear
              </Button>
            </div> : ''}

          </div>
        </form>
      </Grid>
    </Box>
  );
}